import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Layout from '../components/Layout';
import NewDiscountCodeModal from './NewDiscountCodeModal';
import EditDiscountCodeModal from './EditDiscountCodeModal';
import { Card, CardHeader, CardBody, Button, Table } from 'reactstrap';
import moment from 'moment';

const DiscountCodes = () => {
    const [discountCodes, setDiscountCodes] = useState([]);
    const [newDiscountCode, setNewDiscountCode] = useState({
        organization: process.env.REACT_APP_CURRENT_ORGANIZATION_ID,
        code: '',
        discount_amount: '',
        expires_at: null,
        description: ''
    });
    const [editDiscountCode, setEditDiscountCode] = useState(null);
    const [newModalOpen, setNewModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    useEffect(() => {
        fetchDiscountCodes();
    }, []);

    const fetchDiscountCodes = async () => {
        try {
            const response = await api.get('/discount-codes/');
            setDiscountCodes(response.data);
        } catch (error) {
            console.error('Error fetching discount codes:', error);
        }
    };

    const addDiscountCode = async () => {
        try {
            const expiresAt = newDiscountCode.expires_at ? newDiscountCode.expires_at.toISOString() : null;
            await api.post('/discount-codes/', { 
                ...newDiscountCode,
                expires_at: expiresAt 
            });
            fetchDiscountCodes();

            // Reset the form and close the modal
            setNewDiscountCode({
                organization: process.env.REACT_APP_CURRENT_ORGANIZATION_ID,
                code: '',
                discount_amount: '',
                expires_at: '',
                description: ''
            });

            setNewModalOpen(false);
        } catch (error) {
            console.error('Error adding discount code:', error);
        }
    };

    const deleteDiscountCode = async (id) => {
        try {
            await api.delete(`/discount-codes/${id}`);
            fetchDiscountCodes();
        } catch (error) {
            console.error('Error deleting discount code:', error);
        }
    };

    const openEditModal = (code) => {
        setEditDiscountCode(code);
        setEditModalOpen(true);
    };

    const editDiscountCodeData = async () => {
        try {
            if (editDiscountCode.expires_at) {
                editDiscountCode.expires_at = editDiscountCode.expires_at.toISOString();
            }

            await api.put(`/discount-codes/${editDiscountCode.id}/`, editDiscountCode);
            fetchDiscountCodes();
            setEditModalOpen(false);
        } catch (error) {
            console.error('Error editing discount code:', error);
        }
    };

    return (
        <Layout>
            <div style={{ padding: '1rem' }}>
                <Card>
                    <CardHeader tag="h3">Discount Codes</CardHeader>
                    <CardBody>
                        {discountCodes.length === 0 ? (
                            <p>No discount codes found</p>
                        ) : (
                            <Table bordered hover striped>
                                <thead>
                                    <tr>
                                        <th>Code</th>
                                        <th>Description</th>
                                        <th>Discount Amount</th>
                                        <th>Expires</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {discountCodes.map((code) => (
                                        <tr key={code.id}>
                                            <td>{code.code}</td>
                                            <td>{code.description}</td>
                                            <td>${code.discount_amount}</td>
                                            <td>{code.expires_at ? moment(code.expires_at).format('MM/DD/YYYY [at] hh:mm A') : 'N/A'}</td>
                                            <td>
                                                <Button color="primary" onClick={() => openEditModal(code)}>Edit</Button>
                                                {' '}
                                                <Button color="danger" onClick={() => deleteDiscountCode(code.id)}>Delete</Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        )}
                    </CardBody>
                </Card>
            
                <Button color="primary" onClick={() => setNewModalOpen(true)} style={{ marginTop: '10px' }}>Add Discount Code</Button>

                {newModalOpen && (
                    <NewDiscountCodeModal
                        isOpen={newModalOpen}
                        toggle={() => setNewModalOpen(!newModalOpen)}
                        onSave={addDiscountCode}
                        discountCode={newDiscountCode}
                        onInputChange={(name, value) => setNewDiscountCode(prevState => ({ ...prevState, [name]: value }))}
                    />
                )}

                {editDiscountCode && editModalOpen && (
                    <EditDiscountCodeModal
                        isOpen={editModalOpen}
                        toggle={() => setEditModalOpen(!editModalOpen)}
                        onSave={editDiscountCodeData}
                        discountCode={editDiscountCode}
                        onInputChange={(name, value) => setEditDiscountCode(prevState => ({ ...prevState, [name]: value }))}
                    />
                )}
            </div>
        </Layout>
    );
};

export default DiscountCodes;
